import { CheckCircle } from 'lucide-react';

const ThankYou = ({ onBackToLogin }) => {
  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" style={{ background: '#000' }}>
      <style>{`
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes spin-reverse {
          from { transform: rotate(0deg); }
          to { transform: rotate(-360deg); }
        }
        @keyframes pulse-glow {
          0%, 100% { opacity: 1; filter: drop-shadow(0 0 6px #d4922a); }
          50% { opacity: 0.7; filter: drop-shadow(0 0 14px #e8a840); }
        }
        .spin-slow { animation: spin-slow 3s linear infinite; }
        .spin-reverse { animation: spin-reverse 2s linear infinite; }
        .pulse-glow { animation: pulse-glow 2s ease-in-out infinite; }
      `}</style>
      <div className="max-w-lg w-full space-y-8 text-center">
        <div>
          <div className="mx-auto flex items-center justify-center">
            <img src="https://mageguard.net/assets/logo.png" alt="MageGuard" className="h-12" />
          </div>
          <div className="mt-6 flex justify-center">
            <div className="relative flex items-center justify-center" style={{ width: 96, height: 96 }}>
              {/* Outer spinning ring */}
              <svg className="spin-slow absolute inset-0" width="96" height="96" viewBox="0 0 96 96">
                <circle cx="48" cy="48" r="44" fill="none" stroke="rgba(212,146,42,0.15)" strokeWidth="3" />
                <circle cx="48" cy="48" r="44" fill="none" stroke="#d4922a" strokeWidth="3"
                  strokeDasharray="60 218" strokeLinecap="round" />
              </svg>
              {/* Inner spinning ring (reverse) */}
              <svg className="spin-reverse absolute inset-0" width="96" height="96" viewBox="0 0 96 96">
                <circle cx="48" cy="48" r="36" fill="none" stroke="rgba(212,146,42,0.1)" strokeWidth="2" />
                <circle cx="48" cy="48" r="36" fill="none" stroke="rgba(212,146,42,0.5)" strokeWidth="2"
                  strokeDasharray="30 196" strokeLinecap="round" />
              </svg>
              {/* Check icon */}
              <CheckCircle className="pulse-glow h-10 w-10 relative z-10" style={{ color: '#d4922a' }} />
            </div>
          </div>
          <h2 className="mt-4 text-3xl font-extrabold text-white">
            Thank You for Signing Up!
          </h2>
          <p className="mt-4 text-base leading-relaxed" style={{ color: 'rgba(255,255,255,0.7)' }}>
            We are currently scanning your website to ensure that it is on the Magento platform.
            As soon as this finishes you will get an email alert confirming your account is active,
            please allow us a short time to complete the scan.
          </p>
          <p className="mt-4 text-sm" style={{ color: 'rgba(255,255,255,0.5)' }}>
            If you have any questions in the meantime, please contact support.
          </p>
          {onBackToLogin && (
            <button
              onClick={onBackToLogin}
              className="mt-6 text-sm font-medium"
              style={{ color: '#d4922a' }}
            >
              Back to Sign In
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
